export const verificaAcesso = (to, from, next) => {
  const claims = JSON.parse(localStorage.getItem('user')).claims
  const isPremium = claims.find(r => r.name === 'sysPremium')? true : false;

  const temacesso = claims.find((r) => { 
      return r.name === to.meta.rule || r.name === 'sysAdmin';
  })
  if(temacesso || !claims.length || to.meta.rule === '') {
      next()
  } else {
      next({ path: '/semPermissao', name: 'semPermissao' })
  } 
  if(!isPremium && to.meta.rule === 'Relatorio') {
      next({ path: '/semPermissao', name: 'semPermissao' }) 
  }
}
